import { SET_SORT } from '../actions/types';
import { createSort } from '../utils/sorting';

// Default sort is newest first
const initialState = {
	sortType: 'date-descending',
	sortFunction: createSort('date-descending')
};

const setSort = (state = initialState, action) => {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_SORT:
				return {
					sortType: action.payload,
					sortFunction: createSort(action.payload)
				};

			// no default
		}
	}

	return state;
};

export default setSort;
